import React from 'react';
import { SpaceBetween, BreadcrumbGroup, TextContent, Header, Container, Link } from '@amzn/awsui-components-console';
import { copyToClipboard } from '../../lib/utils';
import '../../../styles/custom.scss';

export default function HomeLabMonitor() {
    /**
     * Home Lab Monitor component
     */
    return (
        <SpaceBetween size="s">
            <BreadcrumbGroup
                items={[
                    { text: 'Amazon Device Farm', href: '#/' },
                    {
                        text: 'Home lab monitor',
                        href: '#/home-lab-management/monitor',
                    },
                ]}
            />
            <Header
                variant="h1"
                description="Use below commands to monitor home lab status and disconnect personal system from Amazon Device Farm lab."
            >
                Welcome to Amazon Device Farm - Home lab monitor
            </Header>

            <Container
                header={
                    <Header
                        variant="h2"
                        description="Your system should have active greengrass and OpenVPN service to keep home system established as Amazon Device Farm Lab edge and successfully share devices."
                    >
                        Check lab status
                    </Header>
                }
            >
                <TextContent>
                    <h3>Check Greengrass service status</h3>
                    <ul>
                        <li>
                            <p>Your service should show status as running to have active home lab.</p>
                            {copyToClipboard('sudo systemctl status greengrass.service')}
                        </li>
                    </ul>
                    <h3>Check OpenVPN status</h3>
                    <ul>
                        <li>
                            <p>Your component should show status as running to have active home lab.</p>
                            {copyToClipboard(
                                'sudo /greengrass/v2/bin/greengrass-cli component details --name "com.amazon.ds2.devicefarm.opvnFTDFChild"'
                            )}
                        </li>
                    </ul>
                    <h3>Check home devices are provisioned and usable</h3>
                    <ul>
                        <li>On DeviceFarm home page go to Device Checkout to open FTDF device sharing screen.</li>
                        <li>Search for device by DSN using search bar.</li>
                        <li>Click on use to start using the device to confirm if device screen is shared.</li>
                    </ul>
                </TextContent>
            </Container>
            <Container header={<Header variant="h2">Stop home lab</Header>}>
                <TextContent>
                    <ul>
                        <li>
                            <p>
                                This will disconnect you home system from Device Farm lab and you will no longer be able
                                to share the devices.
                            </p>
                            {copyToClipboard('sudo systemctl stop greengrass.service')}
                        </li>
                    </ul>
                </TextContent>
            </Container>
            <Container header={<Header variant="h2">Start home lab</Header>}>
                <TextContent>
                    <ul>
                        <li>
                            <p>
                                This will connect you home system to Device Farm and you will be able to use it as
                                Device Farm lab to share devices.
                            </p>
                            {copyToClipboard('sudo systemctl start greengrass.service')}
                        </li>
                    </ul>
                </TextContent>
            </Container>
            <Container header={<Header variant="h2">Home lab FAQs</Header>}>
                <Link href="https://w.amazon.com/bin/view/Device_Software_and_Services_DS2/Device_Lab/Palouse/FAQ/Home_Lab/">
                    FAQs
                </Link>
            </Container>
        </SpaceBetween>
    );
}
